import { stores } from 'stores';
import { runInAction } from 'mobx';
import customHistory from 'customHistory';
import routes from 'common/constants/routing.constants';
import { kycStore } from '../stores/kyc.store';
import {
  BLOCKED_DEPOSIT_MODAL_ID,
  BLOCKED_WITHDRAWAL_MODAL_ID,
  KYC_REQUIRED_MODAL_ID,
} from '../constants/profile.constants';

const { ProfileStore, ModalStore } = stores;

class KycService {
  handle403FromPaymentService() {
    const { RequestKYCDoc } = ProfileStore.access;
    if (RequestKYCDoc && kycStore.level < 2) {
      ModalStore.showModal(KYC_REQUIRED_MODAL_ID);
      runInAction(() => {
        kycStore.handling403FromPaymentService = true;
      });
    }
  }

  async beginForcedKyc() {
    if (kycStore.handling403FromPaymentService && kycStore.accepted) {
      try {
        await kycStore.levelUp();
        await kycStore.getStatus();
        runInAction(() => {
          kycStore.handling403FromPaymentService = false;
          kycStore.handling403FromKycService = false;
        });
        ModalStore.pop();
        customHistory.push(routes.kyc.path);
      } catch (err) {
        if (err.status === 403) {
          runInAction(() => {
            kycStore.handling403FromKycService = true;
            kycStore.handling403FromPaymentService = false;
          });
        }
      }
    } else {
      ModalStore.clearStack();
      customHistory.push(routes.kyc.path);
    }
  }

  async doPrePaymentCheck(isDeposit, isDemo) {
    const { access } = ProfileStore;
    if (isDemo) return false;
    await kycStore.getStatus();
    if (!kycStore.accepted) {
      ModalStore.push(KYC_REQUIRED_MODAL_ID);
      return true;
    }
    if (isDeposit && access.BlockDeposit) {
      ModalStore.push(BLOCKED_DEPOSIT_MODAL_ID);
      return true;
    }
    if (!isDeposit && access.BlockWithdraw) {
      ModalStore.push(BLOCKED_WITHDRAWAL_MODAL_ID);
      return true;
    }
    return false;
  }
}

export const kycService = new KycService();
